const { m } = require('minthril');

function Hero() {
  return {
    view: () => m('section.hero',
      m('div.hero__image',
        m('img', {
          src: '/images/Gallardo.webp',
          alt: '',
          fetchpriority: 'high'
        })
      ),
      m('div.hero__content',
        m('div.hero__primary',
          m('p.hero__eyebrow', 'Mid Engine Co'),
          m('h1', 'Parts with a point of view.')
        ),
        m('div.hero__secondary',
          m('p.hero__intro', 'Specialist components, considered upgrades, and hard-to-find pieces for the machines that matter.'),
          m('a.hero__link', { href: '#featured-parts' }, 'Explore the collection ↓'),
          m('p.hero__export', 'Designed on the Gold Coast. Exported worldwide.')
        )
      )
    )
  };
}

module.exports = { Hero };
